import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useItemsList() {
  // Use toast
  const toast = useToast();

  const refItemsListTable = ref(null);

  // filter options
  const itemsStatusOptions = [
    {label: "Active", key: true},
    {label: "Inactive", key: false},
  ];

  // Table Handlers
  const tableColumns = [
    { label: "Nº", key: "index", sortable: true },
    { label: "libellé", key: "name", sortable: true },
    { label: "Marque", key: "brand" },
    { label: "Catégories", key: "categories" },
    { label: "description", key: "description" },
    { label: "Est Amortissable", key: "is_depreciable", sortable: true },
    { key: "actions" },
  ];
  const perPage = ref(10);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("created_at");
  const isSortDirDesc = ref(true);
  const itemStatusFilter = ref(null);

  const itemsList = computed(() => {
    return store.getters["item/all"];
  });

  const totalItems = computed(() => {
    const meta = store.getters["item/meta"];
    return meta.total ?? 0;
  });

  const dataMeta = computed(() => {
    const localItemsCount = refItemsListTable.value
      ? refItemsListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    };
  });

  const refetchData = () => {
    refItemsListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, itemStatusFilter],
    () => {
      refetchData();
    }
  );

  const fetchItemsList = (ctx, callback) => {
    store
      .dispatch("item/fetchItemsList", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        is_active: itemStatusFilter.value,
      })
      .then(() => {
        callback(itemsList.value);
      });
  };

  const deleteItem = async (itemID) => {
    const { data, status } = await store.dispatch("item/destroyItem", {
      id: itemID,
    });
    if (status !== 200) {
      toast({
        component: ToastificationContent,
        props: {
          title: data.error,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    } else {
      toast({
        component: ToastificationContent,
        props: {
          title: "Le produit a été supprimé avec succès.",
          icon: "CheckCircleIcon",
          variant: "success",
        },
      });
      refetchData();
    }
  };

  return {
    fetchItemsList,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refItemsListTable,
    refetchData,
    deleteItem,

    itemStatusFilter,
    itemsStatusOptions,
  };
}
